
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import StickyFilterContainer from '@/components/reports-v3/components/pages/StickyFilterContainer.vue';
import userx from '@/store/modules/userx';
import router from '@/router';
import moment from 'moment';
import TotalQuotationCaseDisplayer from '@/components/reports-v3/components/codedWidgets/sales/SalesTotalQuotationNumberDisplayer.vue';
import ConvertedQuotationCaseDisplayer from '@/components/reports-v3/components/codedWidgets/sales/SalesConvertedQuotationNumberDisplayer.vue';
import OpenQuotationCaseDisplayer from '@/components/reports-v3/components/codedWidgets/sales/SalesOpenQuotationNumberDisplayer.vue';
import SalesProfitAndLossLineChart from '@/components/reports-v3/components/codedWidgets/sales/SalesInvoiceTrendLineChart.vue';
import SalesOrderTrendLineChart from '@/components/reports-v3/components/codedWidgets/sales/SalesOrderTrendLineChart.vue';
import AgentSalesBarChart from '@/components/reports-v3/components/codedWidgets/sales/SalesByAgentsBarChart.vue';
import LastSync from '@/components/LastSync.vue';
import DateRangeFilter from '@/components/reports-v3/components/filters/DateRangeFilter.vue';
import gdbx from '@/store/modules/gdbx';
import AgentSalesMetricTable from '@/components/reports-v3/components/codedWidgets/sales/SalesMetricsTable.vue';
import SalesPeriodComparisonLineChart from '../../components/codedWidgets/sales/SalesPeriodComparisonLineChart.vue';
import TotalSalesComparisonByMonthBarChart from '@/components/reports-v3/components/codedWidgets/sales/SalesTotalSalesComparisonByPeriodBarChart.vue';
import PercentSalesByRegionBarChart from '@/components/reports-v3/components/codedWidgets/sales/SalesOfSalesContributionByRegionBarChart.vue';
import TotalSalesComparisonByRegionBarChart from '@/components/reports-v3/components/codedWidgets/sales/SalesTotalSalesComparisonByRegionBarChart.vue';
import TotalSalesByRegionBarChart from '@/components/reports-v3/components/codedWidgets/sales/SalesTotalSalesByRegionBarChart.vue';
import TotalSalesByIndustryBarChart from '@/components/reports-v3/components/codedWidgets/sales/SalesTotalSalesComparisonByIndustryBarChart.vue';

@Component({
	components: {
    TotalSalesByIndustryBarChart,
    TotalSalesByRegionBarChart,
    TotalSalesComparisonByRegionBarChart,
    PercentSalesByRegionBarChart,
    TotalSalesComparisonByMonthBarChart,
		StickyFilterContainer,
		TotalQuotationCaseDisplayer,
		ConvertedQuotationCaseDisplayer,
		OpenQuotationCaseDisplayer,
		SalesProfitAndLossLineChart,
		AgentSalesBarChart,
		LastSync,
		DateRangeFilter,
		AgentSalesMetricTable,
		SalesPeriodComparisonLineChart,
		SalesOrderTrendLineChart,
	},
})
export default class SalesAnalysis extends Vue {
	public selectedDay: number = moment().endOf('day').valueOf();
	public selectedDateRange: [number, number] = [
		moment().startOf('month').valueOf(),
		moment().endOf('day').valueOf(),
	];

	public mounted() {
		this.track();
	}

	public track() {
		this.$ga.set('userId', userx.user!.uid + '_' + userx.user!.email);
		this.$ga.page(router);
	}

	public get selectedAsOfDate() {
		return moment(this.selectedDay).valueOf();
	}

	public get selectedAgents() {
		return gdbx.allAgents;
	}

	public get selectedStockItems() {
		return gdbx.allStockItems;
	}

	public get selectedCustomers() {
		return gdbx.allCustomers;
	}



	public onHovering(value: boolean, filterId: string) {
		this.$emit('hovering', value, filterId);
	}
	public onEditing(value: boolean, filterId: string) {
		this.$emit('editing', value, filterId);
	}
}
